<div
  class="wheel-tbl scroll-data visible-scroll"
  id="iwheel-calc"
>
  <table
    [class]="{ 'collapse-first-column': collapseApply }"
    (cdkDropListDropped)="tableDrop($event)"
    cdkDropList
    cdkDropListOrientation="horizontal"
  >
    <thead>
      <tr class="droArea">
        <th>
          <div class="save-print">
            <button
              [disabled]="isSaving"
              (click)="onUpdate()"
              type="button"
              mat-button
              class="save-btn"
            >
              {{ isSaving ? 'SAVING...' : 'SAVE' }}
            </button>
            <button
              (click)="collapseColumn()"
              type="button"
              mat-button
              class="collapse-btn"
            >
              <img
                class="light-theme-img"
                src="assets/img/newImg/Collapse.svg"
              />
              <img
                class="black-theme-img"
                src="assets/img/newImg/Collapse-white.svg"
              />
            </button>
          </div>
        </th>
        @for (header of stocks; track header.headerId; let i = $index) {
          <th
            [ngClass]="{ 'disabled-icon': put_headers.length === 1 }"
            class="put-content-column"
            cdkDrag
            cdkDragLockAxis="x"
            cdkDragBoundary="droArea"
          >
            <div class="input-btn-header">
              <img
                src="assets/img/newImg/Move.svg"
                cdkDragHandle
                class="w-print"
              />
              <input
                [value]="'Stock ' + header.headerId"
                class="align-center"
                name="{{ header.headerId }}"
                readonly
                spellcheck="true"
              />
              <div
                [matTooltip]="'Delete column'"
                [matTooltipShowDelay]="0"
                [matTooltipHideDelay]="0"
                [matTooltipPosition]="'below'"
                (click)="onDelete(header.headerId)"
                class="w-delete"
              ></div>
              <div
                [ngClass]="{ 'visibility-w-add-icon': header.headerId == put_headers.length }"
                class="w-add"
              >
                <img
                  (click)="onAdd(i)"
                  src="assets/img/newImg/Add.svg"
                />
              </div>
            </div>
          </th>
          @if (showLiveDataColumn(header.headerId)) {
            <th
              [id]="'live-data-column' + i"
              class="app-live-data-column"
            >
              <app-live-data-header (closeEvent)="unsubscribeAllLiveData()"></app-live-data-header>
            </th>
          }
        }
      </tr>
    </thead>
    <tbody>
      <tr
        [class]="showPutRow ? 'showBelow' : ''"
        class="selling-puts marker-row"
      >
        <th
          (click)="selling('puts')"
          class="heading-text p-0"
        >
          <div class="th-div bg-maroon">#1: Selling Puts</div>
        </th>
        @for (header of put_headers; track header.header_id; let i = $index) {
          <td
            [ngClass]="{ 'active-col': indexOfActiveCol - 1 == i }"
            class="stock"
          >
            <div class="td-ticker">
              <div class="pre-d-input i-100">
                <input
                  [(ngModel)]="header.value"
                  [id]="'put_stock_symbol' + i"
                  (keydown.arrowDown)="$event.stopPropagation()"
                  (keydown.arrowUp)="$event.stopPropagation()"
                  (click)="$event.target.select()"
                  (focus)="addBorderColor($event); onFocusIn(i, 'put')"
                  (focusout)="removeBorderColor($event); onFocusOut(i, header.header_id, 'put')"
                  (keypress)="isInput($event)"
                  (keydown.enter)="focusNext(i, $event)"
                  (input)="input.value = $event.target.value.toUpperCase()"
                  tabindex="1{{ i }}"
                  name="{{ header.name }}"
                  placeholder="Enter Ticker"
                  #input
                  class="align-center"
                  spellcheck="false"
                  autocomplete="off"
                  type="text"
                  maxLength="5"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                />
              </div>
              <div
                [matTooltip]="getLiveDataTooltip(header.header_id, true)"
                [matTooltipHideDelay]="0"
                [matTooltipPosition]="'below'"
                [matTooltipShowDelay]="0"
              >
                <button
                  [disabled]="!canSubscribeToLiveData(header.header_id, true) || isLiveDataSubscriptionInProgress(true)"
                  [appFeatureAvailability]="features.WheelCalculatorLiveData"
                  (click)="subscribeLiveData(header.header_id, true)"
                  mat-icon-button
                  class="square-small-btn refresh-btn not-allowed-when-disabled"
                >
                  <mat-icon
                    [svgIcon]="'refresh-update-icon'"
                    class="watch-icon refresh-icon"
                  ></mat-icon>
                </button>
              </div>
              <div
                [matTooltip]="'Clear section data'"
                [matTooltipShowDelay]="0"
                [matTooltipHideDelay]="0"
                [matTooltipPosition]="'below'"
                (click)="onClearPutOrCall(header.header_id, true)"
                class="w-clear"
              ></div>
              <ng-container *appHideForUnavailableFeature="features.TradingLog">
                <mat-menu
                  #stocksMenu="matMenu"
                  yPosition="below"
                  xPosition="before"
                  class="stocks-dropdown-menu wheel-calc-stocks-menu"
                >
                  @if (canAddToMmTrades && !showTradingLogFormInMenu) {
                    <button
                      (click)="onShowTradingLogForm(trigger); $event.stopPropagation()"
                      mat-menu-item
                    >
                      <span>Add to Trading Log</span>
                    </button>
                    <button
                      (click)="onAddToMmTrades(i, 'put', 'sell', trigger)"
                      mat-menu-item
                    >
                      <span>Add 'Sell Put' to M & M Trades</span>
                    </button>
                  } @else if (
                    openedAddTradeMenuFor && openedAddTradeMenuFor.index === i && openedAddTradeMenuFor.type === 'put'
                  ) {
                    <app-add-trading-log-trade
                      [availableTransactionTypes]="[tlTransactionTypes.SellPut, tlTransactionTypes.BuyPut]"
                      [specificValuesForAvailableTransactionTypes]="
                        openedAddTradeMenuFor.specificValuesForAvailableTransactionTypes
                      "
                      [transactionDetails]="openedAddTradeMenuFor.data"
                      (closeMenu)="trigger.closeMenu()"
                      (contentResized)="onMenuResized(trigger)"
                      class="add-trading-log-trade-component"
                    ></app-add-trading-log-trade>
                  }
                </mat-menu>
                <button
                  [ngClass]="{ active: trigger.menuOpen }"
                  [matMenuTriggerFor]="stocksMenu"
                  (click)="$event.stopPropagation(); onOpenAddTradeMenu(i, 'put')"
                  (menuClosed)="onTradingLogMenuClosed()"
                  mat-icon-button
                  class="stocks-menu-btn-trigger"
                  #trigger="matMenuTrigger"
                  aria-label="Stock's menu dropdown"
                >
                  <mat-icon
                    [svgIcon]="'dashes-icon'"
                    [ngClass]="{ active: trigger.menuOpen }"
                    class="dashes-menu-icon"
                  ></mat-icon>
                </button>
              </ng-container>
            </div>
          </td>
          @if (showLiveDataColumn(header.header_id)) {
            <td
              [ngClass]="{ 'collapsed-call-row': !showCallRow }"
              rowspan="26"
              class="real-time-data-cell"
            >
              <app-window
                [roiLowerBound]="roiLowerBound"
                [roiUpperBound]="roiUpperBound"
                [putSubscription]="putSubscription"
                [putOptionsChain]="putOptionsChain"
                [callSubscription]="callSubscription"
                [callOptionsChain]="callOptionsChain"
                [collapsedCallRow]="!showCallRow"
                [collapsedPutRow]="!showPutRow"
                [tradierFlags]="tradierFlags"
                [isPutTimeout]="isPutSubscriptionTimeoutTriggered"
                [isCallTimeout]="isCallSubscriptionTimeoutTriggered"
                [isPutUpdateOverlay]="isPutUpdateOverlay"
                [isCallUpdateOverlay]="isCallUpdateOverlay"
                (putClickEvent)="liveDataPutClick($event)"
                (callClickEvent)="liveDataCallClick($event)"
                (putRetryEvent)="liveDataPutRetry()"
                (callRetryEvent)="liveDataCallRetry()"
              >
              </app-window>
            </td>
          }
        }
      </tr>
      <tr class="s-puts marker-row">
        <th>
          <div class="th-div">Stock Price</div>
        </th>
        @for (stock of put_stock_price; track stock.header_id; let i = $index) {
          <td
            [ngClass]="{ 'active-col': indexOfActiveCol - 1 == i }"
            class="stock"
          >
            <div class="pre-d-input">
              <div class="pre-sign">$</div>
              <input
                [(ngModel)]="stock.value"
                [id]="'put_stock_price' + i"
                [inputMask]="stockPriceInputMask"
                (focus)="addBorderColor($event); onFocusIn(i, 'put')"
                (focusout)="removeBorderColor($event)"
                (click)="$event.target.select()"
                (keyup)="onKeyUp($event, stock.header_id, 'put_stock_price', i)"
                (keydown.enter)="focusNext(i, $event)"
                (keydown)="onKeyDown($event, 'put_stock_price', i, '0.01', '999999')"
                type="text"
                tabindex="1{{ i }}"
                min="0"
                placeholder="0.00"
                maxlength="10"
                autocomplete="off"
                name="{{ stock.name }}"
              />
            </div>
          </td>
        }
      </tr>
      <tr class="s-puts marker-row">
        <th>
          <div class="th-div">Expiration</div>
        </th>
        @for (stock of put_dte; track stock.header_id; let i = $index) {
          <td
            [ngClass]="{ 'active-col': indexOfActiveCol - 1 == i }"
            class="stock"
          >
            <mat-form-field
              class="date-select-field"
              appearance="outline"
              subscriptSizing="dynamic"
            >
              <mat-select
                [(ngModel)]="stock.expiration"
                (click)="$event.stopPropagation()"
                (focus)="addBorderColor($event); onFocusIn(i, 'put')"
                (keydown.arrowDown)="$event.stopPropagation()"
                (keydown.arrowUp)="$event.stopPropagation()"
                (focusout)="removeBorderColor($event)"
                (selectionChange)="onKeyUp($event, stock.header_id, 'put_dte', i); focusNext(i, $event)"
                (selected)="onKeyUp($event, stock.header_id, 'put_dte', i)"
                class="date-mdc-select"
                id="{{ 'tabIndexs1' + i }}"
                autocomplete="off"
                name="{{ stock.name }}"
                panelClass="date-mdc-select-options"
              >
                <!-- Note: track index is antipattern, but it is OK for this case (legacy) -->
                @for (date of dates; track i; let i = $index) {
                  <mat-option [value]="date">{{ date | date: 'MMM d, y' }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <p
              [ngStyle]="{ visibility: !checkIfEmpty('expiration', true, i) ? '' : 'hidden' }"
              class="s-content underline"
            >
              DTE: {{ stock.dte }} Day{{ stock.dte <= 1 ? '' : 's' }}
            </p>
            <div class="min-premium">
              @if (put_min_premiums[i]?.length) {
                <div class="table-container scroll-style">
                  <table>
                    <thead>
                      <tr>
                        <th>Day</th>
                        <th>DTE, days</th>
                        <th>Min Premium (30% ROI)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <!-- Note: track index is antipattern, but it is OK for this case (legacy) -->
                      @for (min_premium of put_min_premiums[i]; track j; let j = $index) {
                        <tr>
                          <td>
                            {{ min_premium.day }}
                          </td>
                          <td>
                            {{ min_premium.dte }}
                          </td>
                          <td>
                            {{ min_premium.min_roi }}
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              }
              @if (!put_min_premiums[i]?.length) {
                <app-no-data-message
                  [message]="'Please specify Strike Price and Expiration and try again.'"
                  [additionalMessage]="' '"
                ></app-no-data-message>
              }
            </div>
          </td>
        }
      </tr>
      <tr class="s-puts marker-row">
        <th>
          <div class="th-div">Strike Price</div>
        </th>
        @for (stock of put_strike_price; track stock.header_id; let i = $index) {
          <td
            [ngClass]="{ 'active-col': indexOfActiveCol - 1 == i }"
            class="stock"
          >
            <div class="pre-d-input">
              <div class="pre-sign">$</div>
              <input
                [(ngModel)]="stock.value"
                [id]="'put_strike_price' + i"
                [inputMask]="strikePriceInputMask"
                (keyup)="onKeyUp($event, stock.header_id, 'put_strike_price', i)"
                (click)="$event.target.select()"
                (keydown.enter)="focusNext(i, $event)"
                (keydown)="onKeyDown($event, 'put_strike_price', i, '0.5', '999999')"
                (focus)="addBorderColor($event); onFocusIn(i, 'put')"
                (focusout)="removeBorderColor($event)"
                type="text"
                tabindex="1{{ i }}"
                autocomplete="off"
                placeholder="0.00"
                min="0"
                maxlength="10"
                step="0.5"
                name="{{ stock.name }}"
              />
            </div>
          </td>
        }
      </tr>
      <tr class="s-puts marker-row">
        <th>
          <div class="th-div">Premium</div>
        </th>
        @for (stock of put_premium; track stock.header_id; let i = $index) {
          <td
            [ngClass]="{ 'active-col': indexOfActiveCol - 1 == i }"
            class="stock"
          >
            <div class="pre-d-input">
              <div class="pre-sign">$</div>
              <input
                [(ngModel)]="stock.value"
                [id]="'put_premium' + i"
                [inputMask]="currencyInputMask"
                (click)="$event.target.select()"
                (keyup)="onKeyUp($event, stock.header_id, 'put_premium', i)"
                (keydown)="onKeyDown($event, 'put_premium', i, '0.01', '999')"
                (focus)="addBorderColor($event); onFocusIn(i, 'put')"
                (focusout)="removeBorderColor($event)"
                (keydown.enter)="focusNext(i, $event)"
                type="text"
                tabindex="1{{ i }}"
                step="0.01"
                min="0"
                autocomplete="off"
                placeholder="0.00"
                maxlength="6"
                name="{{ stock.name }}"
              />
            </div>
            <div
              [ngStyle]="{
                visibility:
                  !checkIfEmpty('strike', true, i) && !checkIfEmpty('expiration', true, i) && isFinit(stock.value)
                    ? ''
                    : 'hidden',
              }"
              class="bottom-min-max"
            >
              <p
                [ngStyle]="{ visibility: stock.min !== null && isFinit(stock.min) ? '' : 'hidden' }"
                class="red underline"
              >
                Min:
                <span>${{ stock.min | number: '1.2-2' }}</span>
              </p>
              <p
                [ngStyle]="{ visibility: stock.max !== null && isFinit(stock.max) ? '' : 'hidden' }"
                class="green"
              >
                Max:
                <span>${{ stock.max | number: '1.2-2' }}</span>
              </p>
              <div class="min-premium">
                @if (put_min_premiums[i]?.length) {
                  <div class="table-container scroll-style">
                    <table>
                      <thead>
                        <tr>
                          <th>Day</th>
                          <th>DTE, days</th>
                          <th>Min Premium (30% ROI)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <!-- Note: track index is antipattern, but it is OK for this case (legacy) -->
                        @for (min_premium of put_min_premiums[i]; track j; let j = $index) {
                          <tr>
                            <td>
                              {{ min_premium.day }}
                            </td>
                            <td>
                              {{ min_premium.dte }}
                            </td>
                            <td>
                              {{ min_premium.min_roi }}
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                }
                @if (!put_min_premiums[i]?.length) {
                  <app-no-data-message
                    [message]="'Please specify Strike Price and Expiration and try again.'"
                    [additionalMessage]="' '"
                  ></app-no-data-message>
                }
              </div>
            </div>
          </td>
        }
      </tr>
      <tr class="s-puts marker-row">
        <th>
          <div class="th-div"># Option to Trade</div>
        </th>
        @for (stock of put_option_to_trade; track stock.header_id; let i = $index) {
          <td
            [ngClass]="{ 'active-col': indexOfActiveCol - 1 == i }"
            class="stock"
          >
            <div
              [class]="showTradeLink() && !isValueZero(i, ['strike'], true) ? 'with-trade-btn' : ''"
              class="left-i-right-c"
            >
              <div
                [ngStyle]="{
                  visibility: !checkIfEmpty('strike', true, i) ? '' : 'hidden',
                }"
                class="whiteDiv w-100"
              >
                <div class="row w-100 round-div text-left">
                  <div
                    [class.is-manual]="stock.isManual"
                    [class.reset-space-reserved]="!(stock.isManual && isFinit(stock.autoValue))"
                    [class.has-quantity-warning]="isPutContractsQuantityUnusual(stock)"
                    [matTooltip]="putUnusualContractsTooltip"
                    [matTooltipDisabled]="!isPutContractsQuantityUnusual(stock)"
                    [matTooltipPosition]="'below'"
                    [matTooltipHideDelay]="0"
                    matTooltipClass="option-to-trade-tooltip"
                    class="round-div-item option-to-trade"
                  >
                    <input
                      [ngModel]="stock.value"
                      [name]="stock.name + '-put-option-to-trade'"
                      (ngModelChange)="onOptionToTradeChange($event, stock.header_id, i, true)"
                      (keydown)="onOptionToTradeKeyDown($event)"
                      (click)="$event.target.select()"
                      (focus)="onFocusIn(i, 'put')"
                      type="text"
                      inputmode="numeric"
                      maxlength="4"
                      autocomplete="off"
                    />
                  </div>
                  @if (showTradeLink() && !isValueZero(i, ['strike'], true)) {
                    <div
                      [class]="isPlaceOrderDisabled(i, ['expiration', 'ticker', 'premium'], true) ? 'disabled' : ''"
                      [class.reset-space-reserved]="!(stock.isManual && isFinit(stock.autoValue))"
                      [matTooltip]="putTradeLinkTooltip[i]"
                      [matTooltipDisabled]="!putTradeLinkTooltipEnabled[i]"
                      [matTooltipPosition]="'below'"
                      [matTooltipHideDelay]="0"
                      class="trade-btn"
                    >
                      @if (isPlaceOrderDisabled(i, ['expiration', 'ticker', 'premium'], true)) {
                        <a> Place Order </a>
                      } @else {
                        <a (click)="tradeLinkTradingPanel(i, stock, 'P')">Place Order</a>
                      }
                    </div>
                  }
                  @if (stock.isManual && isFinit(stock.autoValue)) {
                    <a
                      (click)="resetOptionToTrade(stock.header_id, i, true)"
                      class="reset-to-auto"
                    >
                      <mat-icon
                        [svgIcon]="'refresh-small'"
                        class="reset-to-auto-icon"
                      ></mat-icon>
                      <span>Reset to auto ({{ stock.autoValue }})</span>
                    </a>
                  }
                  <p
                    [class.position-value-warning]="isPutContractsQuantityUnusual(stock)"
                    [matTooltip]="putUnusualContractsTooltip"
                    [matTooltipDisabled]="!isPutContractsQuantityUnusual(stock)"
                    [matTooltipPosition]="'below'"
                    [matTooltipHideDelay]="0"
                    matTooltipClass="option-to-trade-tooltip"
                    [ngStyle]="{
                      visibility:
                        !checkIfEmpty('strike', true, i) && stock.need_to_buy !== null && isFinit(stock.need_to_buy)
                          ? ''
                          : 'hidden',
                    }"
                  >
                    Position value
                    @if (!showTradeLink()) {
                      <br />
                    }
                    ${{ stock.need_to_buy | number: '1.0-0' }}
                  </p>
                </div>
              </div>
            </div>
          </td>
        }
      </tr>
      <tr class="s-puts marker-row pb-0">
        <th>
          <div class="th-div">Drop In</div>
        </th>
        @for (stock of drop; track stock.header_id; let i = $index) {
          <td
            [ngClass]="{ 'active-col': indexOfActiveCol - 1 == i }"
            class="stock"
          >
            <div
              [ngStyle]="{
                visibility:
                  !checkIfEmpty('stock', true, i) &&
                  !checkIfEmpty('strike', true, i) &&
                  stock.value !== null &&
                  isFinit(stock.value)
                    ? ''
                    : 'hidden',
              }"
              class="wh-100 all-center drop-in"
              class="{{ getBGLightColor(i, true) }}"
            >
              <div class="down-arrow"></div>
              {{ stock.value | number: '1.0-0' }}%
            </div>
          </td>
        }
      </tr>
      <tr class="s-puts marker-row ptb-0">
        <th>
          <div class="th-div">Premium Per Day. <span>Total</span></div>
        </th>
        @for (stock of put_premium_per_day; track stock.header_id; let i = $index) {
          <td
            [ngClass]="{ 'active-col': indexOfActiveCol - 1 == i }"
            class="stock"
          >
            <div
              [ngStyle]="{
                visibility:
                  !checkIfEmpty('premium', true, i) &&
                  !checkIfEmpty('strike', true, i) &&
                  stock.premium_per_day !== null &&
                  isFinit(stock.premium_per_day)
                    ? ''
                    : 'hidden',
              }"
              class="whiteDiv premium-per-day"
              class="{{ getBGLightColor(i, true) }}"
            >
              <div
                [ngStyle]="{
                  visibility:
                    !checkIfEmpty('premium', true, i) &&
                    !checkIfEmpty('strike', true, i) &&
                    !checkIfEmpty('expiration', true, i) &&
                    stock.premium_per_day !== null &&
                    isFinit(stock.premium_per_day)
                      ? ''
                      : 'hidden',
                }"
              >
                ${{ stock.premium_per_day | number: '1.0-0' }}
              </div>
              <div
                [ngStyle]="{
                  visibility:
                    !checkIfEmpty('premium', true, i) &&
                    !checkIfEmpty('strike', true, i) &&
                    isFinit(stock.premium_collected)
                      ? ''
                      : 'hidden',
                }"
                class="blur-rr"
              >
                ${{ stock.premium_collected | number: '1.0-0' }}
              </div>
            </div>
          </td>
        }
      </tr>
      <tr class="s-puts marker-row pt-0">
        <th>
          <div class="th-div">
            <svg
              [matTooltip]="roiLegend"
              [matTooltipPosition]="'below'"
              [matTooltipHideDelay]="0"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 16 16"
              class="help"
            >
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
              <path
                d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"
              /></svg
            >Premium Annualized
          </div>
        </th>
        @for (stock of put_premium_annualarized; track stock.header_id; let i = $index) {
          <td
            [ngClass]="{ 'active-col': indexOfActiveCol - 1 == i }"
            class="stock"
          >
            @if (stock.value > roiUpperBound) {
              <div
                [ngStyle]="{
                  visibility:
                    !checkIfEmpty('expiration', true, i) &&
                    !checkIfEmpty('premium', true, i) &&
                    stock.value !== null &&
                    isFinit(stock.value)
                      ? ''
                      : 'hidden',
                }"
                class="bg-yellow"
              >
                {{ stock.value | number: '1.0-0' }}%
              </div>
            }
            @if (stock.value < roiLowerBound || !stock.value) {
              <div
                [ngStyle]="{
                  visibility:
                    !checkIfEmpty('expiration', true, i) &&
                    !checkIfEmpty('premium', true, i) &&
                    stock.value !== null &&
                    isFinit(stock.value)
                      ? ''
                      : 'hidden',
                }"
                class="bg-red"
              >
                {{ stock.value | number: '1.0-0' }}%
              </div>
            }
            @if (stock.value >= roiLowerBound && stock.value <= roiUpperBound) {
              <div
                [ngStyle]="{
                  visibility:
                    !checkIfEmpty('expiration', true, i) &&
                    !checkIfEmpty('premium', true, i) &&
                    stock.value !== null &&
                    isFinit(stock.value)
                      ? ''
                      : 'hidden',
                }"
                class="bg-green"
              >
                {{ stock.value | number: '1.0-0' }}%
              </div>
            }
          </td>
        }
      </tr>

      <tr class="s-puts marker-row">
        <th>
          <div class="th-div">
            <svg
              [matTooltip]="putProfit90Tooltip"
              [matTooltipPosition]="'below'"
              [matTooltipHideDelay]="0"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 16 16"
              class="help"
            >
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
              <path
                d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"
              />
            </svg>
            90% Profit.
            <ul>
              <li>Target</li>
              <li>Value</li>
            </ul>
          </div>
        </th>
        @for (stock of put_profit; track stock.header_id; let i = $index) {
          <td
            [ngClass]="{ 'active-col': indexOfActiveCol - 1 == i }"
            class="stock"
          >
            <div class="whiteDiv value-center-dotted">
              <div>
                @if (showTradeLink() && profitLinkShow(i, true) && !isValueZero(i, ['strike'], true)) {
                  <div>
                    <div
                      [class]="tradeLinkTradingPanelDisable(i, ['expiration', 'ticker'], true) ? 'disabled' : ''"
                      class="wheel-profit-link"
                    >
                      @if (tradeLinkTradingPanelDisable(i, ['expiration', 'ticker'], true)) {
                        <a
                          [matTooltip]="tradeLinkTooltip"
                          [matTooltipDisabled]="!tradeLinkTooltipEnabled"
                          [matTooltipPosition]="'below'"
                        >
                          ${{ stock.taking | number: '1.2-2' }}
                        </a>
                      } @else {
                        <a (click)="profitLinkTradingPanel(i, 'P', stock.taking)">
                          ${{ stock.taking | number: '1.2-2' }}
                        </a>
                      }
                    </div>
                  </div>
                } @else {
                  <div
                    [ngStyle]="{
                      visibility:
                        !checkIfEmpty('premium', true, i) && stock.taking !== null && isFinit(stock.taking)
                          ? ''
                          : 'hidden',
                    }"
                  >
                    ${{ stock.taking | number: '1.2-2' }}
                  </div>
                }
              </div>
              <div
                [ngStyle]="{
                  visibility:
                    !checkIfEmpty('strike', true, i) &&
                    !checkIfEmpty('premium', true, i) &&
                    stock.value !== null &&
                    isFinit(stock.value)
                      ? ''
                      : 'hidden',
                }"
              >
                ${{ stock.value | number: '1.2-2' }}
              </div>
            </div>
          </td>
        }
      </tr>

      <tr
        [class]="showCallRow ? 'showBelow' : ''"
        class="selling-calls marker-row"
      >
        <th
          (click)="selling('calls')"
          class="heading-text p-0"
        >
          <div class="th-div bg-maroon">#2: Selling Calls</div>
        </th>

        @for (header of call_symbol; track header.header_id; let i = $index) {
          <td
            [ngClass]="{ 'active-col': indexOfActiveCol - 1 == i }"
            class="stock"
          >
            <div class="td-ticker">
              <div class="pre-d-input i-100">
                <input
                  [(ngModel)]="header.value"
                  [id]="'call_stock_symbol' + i"
                  (click)="$event.target.select()"
                  (keydown.arrowDown)="$event.stopPropagation()"
                  (keydown.arrowUp)="$event.stopPropagation()"
                  (input)="input.value = $event.target.value.toUpperCase()"
                  (keydown.enter)="focusNext(i, $event)"
                  (focus)="addBorderColor($event); onFocusIn(i, 'call')"
                  (keypress)="isInput($event)"
                  (focusout)="removeBorderColor($event); onFocusOut(i, header.header_id, 'call')"
                  name="{{ header.name }}"
                  tabindex="1{{ i }}"
                  spellcheck="true"
                  autocomplete="off"
                  placeholder="Enter Ticker"
                  #input
                  class="align-center"
                  spellcheck="false"
                  type="text"
                  maxlength="5"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                />
              </div>
              <div
                [matTooltip]="getLiveDataTooltip(header.header_id, false)"
                [matTooltipHideDelay]="0"
                [matTooltipShowDelay]="0"
                [matTooltipPosition]="'below'"
              >
                <button
                  [disabled]="
                    !canSubscribeToLiveData(header.header_id, false) || isLiveDataSubscriptionInProgress(false)
                  "
                  [appFeatureAvailability]="features.WheelCalculatorLiveData"
                  (click)="subscribeLiveData(header.header_id, false)"
                  mat-icon-button
                  class="square-small-btn refresh-btn not-allowed-when-disabled"
                >
                  <mat-icon
                    [svgIcon]="'refresh-update-icon'"
                    class="watch-icon refresh-icon"
                  ></mat-icon>
                </button>
              </div>
              <div
                [matTooltip]="'Clear section data'"
                [matTooltipShowDelay]="0"
                [matTooltipHideDelay]="0"
                [matTooltipPosition]="'below'"
                (click)="onClearPutOrCall(header.header_id, false)"
                class="w-clear"
              ></div>
              <ng-container *appHideForUnavailableFeature="features.TradingLog">
                <mat-menu
                  #stocksMenu="matMenu"
                  yPosition="below"
                  xPosition="before"
                  class="stocks-dropdown-menu wheel-calc-stocks-menu"
                >
                  @if (canAddToMmTrades && !showTradingLogFormInMenu) {
                    <button
                      (click)="onShowTradingLogForm(trigger); $event.stopPropagation()"
                      mat-menu-item
                    >
                      <span>Add to Trading Log</span>
                    </button>
                    <button
                      (click)="onAddToMmTrades(i, 'call', 'sell', trigger)"
                      mat-menu-item
                    >
                      <span>Add 'Sell Call' to M & M Trades</span>
                    </button>
                  } @else if (
                    openedAddTradeMenuFor && openedAddTradeMenuFor.index === i && openedAddTradeMenuFor.type === 'call'
                  ) {
                    <app-add-trading-log-trade
                      [availableTransactionTypes]="[tlTransactionTypes.SellCall, tlTransactionTypes.BuyCall]"
                      [specificValuesForAvailableTransactionTypes]="
                        openedAddTradeMenuFor.specificValuesForAvailableTransactionTypes
                      "
                      [transactionDetails]="openedAddTradeMenuFor.data"
                      (closeMenu)="trigger.closeMenu()"
                      (contentResized)="onMenuResized(trigger); trigger.updatePosition()"
                      class="add-trading-log-trade-component"
                    ></app-add-trading-log-trade>
                  }
                </mat-menu>
                <button
                  [ngClass]="{ active: trigger.menuOpen }"
                  [matMenuTriggerFor]="stocksMenu"
                  (click)="$event.stopPropagation(); onOpenAddTradeMenu(i, 'call')"
                  (menuClosed)="onTradingLogMenuClosed()"
                  mat-icon-button
                  class="stocks-menu-btn-trigger"
                  #trigger="matMenuTrigger"
                  aria-label="Stock's menu dropdown"
                >
                  <mat-icon
                    [svgIcon]="'dashes-icon'"
                    [ngClass]="{ active: trigger.menuOpen }"
                    class="dashes-menu-icon"
                  ></mat-icon>
                </button>
              </ng-container>
            </div>
          </td>
        }
      </tr>
      <tr class="s-calls marker-row">
        <th>
          <div class="th-div">Stock Purchase Price</div>
        </th>
        @for (stock of call_stock_price; track stock.header_id; let i = $index) {
          <td
            [ngClass]="{ 'active-col': indexOfActiveCol - 1 == i }"
            class="stock"
          >
            <div class="pre-d-input">
              <div class="pre-sign">$</div>
              <input
                [(ngModel)]="stock.value"
                [id]="'call_stock_price' + i"
                [inputMask]="stockPurchasePriceInputMask"
                (click)="$event.target.select()"
                (keyup)="onKeyUp($event, stock.header_id, 'call_stock_price', i)"
                (keydown)="onKeyDown($event, 'call_stock_price', i, '0.01', '999999')"
                (keydown.enter)="focusNext(i, $event)"
                (focus)="addBorderColor($event); onFocusIn(i, 'call')"
                (focusout)="onAddDecimals('call_stock_price', i); removeBorderColor($event)"
                type="text"
                tabindex="1{{ i }}"
                autocomplete="off"
                min="0"
                step="0.01"
                maxlength="10"
                placeholder="0.00"
                name="{{ stock.name }}"
              />
            </div>
          </td>
        }
      </tr>
      <tr class="s-calls marker-row">
        <th>
          <div class="th-div">Expiration</div>
        </th>
        @for (stock of call_expiration; track stock.header_id; let i = $index) {
          <td
            [ngClass]="{ 'active-col': indexOfActiveCol - 1 == i }"
            class="stock"
          >
            <mat-form-field
              class="date-select-field"
              appearance="outline"
              subscriptSizing="dynamic"
            >
              <mat-select
                [(ngModel)]="stock.expiration"
                (click)="$event.stopPropagation()"
                (keydown.arrowDown)="$event.stopPropagation()"
                (keydown.arrowUp)="$event.stopPropagation()"
                (selectionChange)="onKeyUp($event, stock.header_id, 'call_dte', i); focusNext(i, $event)"
                (selected)="onKeyUp($event, stock.header_id, 'call_dte', i)"
                (focus)="addBorderColor($event); onFocusIn(i, 'call')"
                (focusout)="removeBorderColor($event)"
                class="date-mdc-select"
                id="{{ 'tabIndexs2' + i }}"
                autocomplete="off"
                name="{{ stock.name }}"
                panelClass="date-mdc-select-options"
              >
                <!-- Note: track index is antipattern, but it is OK for this case (legacy) -->
                @for (date of dates; track i; let i = $index) {
                  <mat-option [value]="date">{{ date | date: 'MMM d, y' }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <p
              [ngStyle]="{ visibility: !checkIfEmpty('expiration', false, i) ? '' : 'hidden' }"
              class="s-content underline"
            >
              DTE: {{ stock.dte }} Day{{ stock.dte <= 1 ? '' : 's' }}
            </p>
            <div class="min-premium">
              @if (call_min_premiums[i]?.length) {
                <div class="table-container scroll-style">
                  <table>
                    <thead>
                      <tr>
                        <th>Day</th>
                        <th>DTE, days</th>
                        <th>Min Premium (30% ROI)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <!-- Note: track index is antipattern, but it is OK for this case (legacy) -->
                      @for (min_premium of call_min_premiums[i]; track j; let j = $index) {
                        <tr>
                          <td>
                            {{ min_premium.day }}
                          </td>
                          <td>
                            {{ min_premium.dte }}
                          </td>
                          <td>
                            {{ min_premium.min_roi }}
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              }
              @if (!call_min_premiums[i]?.length) {
                <app-no-data-message
                  [message]="'Please specify Stock Purchase Price and Expiration and try again.'"
                  [additionalMessage]="' '"
                ></app-no-data-message>
              }
            </div>
          </td>
        }
      </tr>
      <tr class="s-calls marker-row">
        <th>
          <div class="th-div">Shares</div>
        </th>
        @for (stock of call_no_of_shares; track stock.header_id; let i = $index) {
          <td
            [ngClass]="{ 'active-col': indexOfActiveCol - 1 == i }"
            class="stock"
          >
            <div class="pre-d-input">
              <div class="pre-sign v-hidden">$</div>
              <input
                [(ngModel)]="stock.value"
                [id]="'call_no_of_shares' + i"
                [inputMask]="sharesInputMask"
                (click)="$event.target.select()"
                (focus)="addBorderColor($event); onFocusIn(i, 'call')"
                (focusout)="removeBorderColor($event)"
                (keyup)="onKeyUp($event, stock.header_id, 'call_no_of_shares', i)"
                (keydown.enter)="focusNext(i, $event)"
                (keydown)="onKeyDown($event, 'call_no_of_shares', i, '100', '999999')"
                type="text"
                tabindex="1{{ i }}"
                min="0"
                maxlength="7"
                placeholder="0"
                autocomplete="off"
                name="{{ stock.name }}"
              />
            </div>
          </td>
        }
      </tr>
      <tr class="s-calls marker-row">
        <th>
          <div class="th-div">Strike Price</div>
        </th>
        @for (stock of call_strike_price; track stock.header_id; let i = $index) {
          <td
            [ngClass]="{ 'active-col': indexOfActiveCol - 1 == i }"
            class="stock"
          >
            <div class="pre-d-input">
              <div class="pre-sign">$</div>
              <input
                [(ngModel)]="stock.value"
                [id]="'call_strike_price' + i"
                [inputMask]="strikePriceInputMask"
                (click)="$event.target.select()"
                (focus)="addBorderColor($event); onFocusIn(i, 'call')"
                (focusout)="removeBorderColor($event)"
                (keyup)="onKeyUp($event, stock.header_id, 'call_strike_price', i)"
                (keydown.enter)="focusNext(i, $event)"
                (keydown)="onKeyDown($event, 'call_strike_price', i, '0.5', '999999')"
                type="text"
                tabindex="1{{ i }}"
                min="0"
                maxlength="10"
                step="0.5"
                placeholder="0.00"
                autocomplete="off"
                name="{{ stock.name }}"
              />
            </div>
          </td>
        }
      </tr>
      <tr class="s-calls marker-row">
        <th>
          <div class="th-div">Premium</div>
        </th>
        @for (stock of call_option_premium; track stock.header_id; let i = $index) {
          <td
            [ngClass]="{ 'active-col': indexOfActiveCol - 1 == i }"
            class="stock"
          >
            <div class="pre-d-input">
              <div class="pre-sign">$</div>
              <input
                [(ngModel)]="stock.value"
                [id]="'call_option_premium' + i"
                [inputMask]="currencyInputMask"
                (click)="$event.target.select()"
                (keyup)="onKeyUp($event, stock.header_id, 'call_option_premium', i)"
                (keydown.enter)="focusNext(i, $event)"
                (keydown)="onKeyDown($event, 'call_option_premium', i, '0.01', '999')"
                (focus)="addBorderColor($event); onFocusIn(i, 'call')"
                (focusout)="removeBorderColor($event)"
                type="text"
                tabindex="1{{ i }}"
                min="0"
                autocomplete="off"
                step="0.01"
                maxlength="6"
                placeholder="0.00"
              />
            </div>
            <div class="bottom-min-max">
              <p
                [ngStyle]="{
                  visibility:
                    !checkIfEmpty('stock', false, i) &&
                    !checkIfEmpty('expiration', false, i) &&
                    stock.min !== null &&
                    isFinit(stock.min)
                      ? ''
                      : 'hidden',
                }"
                class="red underline"
              >
                Min: ${{ stock.min | number: '1.2-2' }}
              </p>
              <div class="min-premium">
                @if (call_min_premiums[i]?.length) {
                  <div class="table-container scroll-style">
                    <table>
                      <thead>
                        <tr>
                          <th>Day</th>
                          <th>DTE, days</th>
                          <th>Min Premium (30% ROI)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <!-- Note: track index is antipattern, but it is OK for this case (legacy) -->
                        @for (min_premium of call_min_premiums[i]; track j; let j = $index) {
                          <tr>
                            <td>
                              {{ min_premium.day }}
                            </td>
                            <td>
                              {{ min_premium.dte }}
                            </td>
                            <td>
                              {{ min_premium.min_roi }}
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                }
                @if (!call_min_premiums[i]?.length) {
                  <app-no-data-message
                    [message]="'Please specify Stock Purchase Price and Expiration and try again.'"
                    [additionalMessage]="' '"
                  ></app-no-data-message>
                }
              </div>
            </div>
          </td>
        }
      </tr>
      <tr class="s-calls marker-row">
        <th>
          <div class="th-div"># Option to Trade</div>
        </th>
        @for (stock of call_option_to_trade; track stock.header_id; let i = $index) {
          <td
            [ngClass]="{ 'active-col': indexOfActiveCol - 1 == i }"
            class="stock"
          >
            <div
              [class]="showTradeLink() && !isValueZero(i, ['share'], false) ? 'with-trade-btn' : ''"
              class="left-i-right-c"
            >
              <div class="whiteDiv w-100">
                <div class="row w-100 round-div text-left">
                  <div
                    [ngStyle]="{ visibility: !checkIfEmpty('share', false, i) ? '' : 'hidden' }"
                    [class.is-manual]="stock.isManual"
                    [class.reset-space-reserved]="!(stock.isManual && isFinit(stock.autoValue))"
                    [class.has-quantity-error]="isCallContractsExceedingShares(i, stock)"
                    [matTooltip]="callContractsExceedSharesTooltip"
                    [matTooltipDisabled]="!isCallContractsExceedingShares(i, stock)"
                    [matTooltipPosition]="'below'"
                    [matTooltipHideDelay]="0"
                    matTooltipClass="option-to-trade-tooltip"
                    class="round-div-item option-to-trade"
                  >
                    <input
                      [ngModel]="stock.value"
                      [name]="stock.name + '-call-option-to-trade'"
                      (ngModelChange)="onOptionToTradeChange($event, stock.header_id, i, false)"
                      (keydown)="onOptionToTradeKeyDown($event)"
                      (click)="$event.target.select()"
                      (focus)="onFocusIn(i, 'call')"
                      type="text"
                      inputmode="numeric"
                      maxlength="4"
                      autocomplete="off"
                    />
                  </div>
                  @if (showTradeLink() && !isValueZero(i, ['share'], false)) {
                    <div
                      [class]="
                        isPlaceOrderDisabled(i, ['expiration', 'ticker', 'premium', 'strike'], false, stock)
                          ? 'disabled'
                          : ''
                      "
                      [class.reset-space-reserved]="!(stock.isManual && isFinit(stock.autoValue))"
                      [matTooltip]="callTradeLinkTooltip[i]"
                      [matTooltipDisabled]="!callTradeLinkTooltipEnabled[i]"
                      [matTooltipPosition]="'below'"
                      [matTooltipHideDelay]="0"
                      matTooltipClass="option-to-trade-tooltip"
                      class="trade-btn"
                    >
                      @if (isPlaceOrderDisabled(i, ['expiration', 'ticker', 'premium', 'strike'], false, stock)) {
                        <a> Place Order </a>
                      } @else {
                        <a (click)="tradeLinkTradingPanel(i, stock, 'C')">Place Order</a>
                      }
                    </div>
                  }
                  @if (stock.isManual && isFinit(stock.autoValue)) {
                    <a
                      (click)="resetOptionToTrade(stock.header_id, i, false)"
                      class="reset-to-auto"
                    >
                      <mat-icon
                        [svgIcon]="'refresh-small'"
                        class="reset-to-auto-icon"
                      ></mat-icon>
                      <span>Reset to auto ({{ stock.autoValue }})</span>
                    </a>
                  }
                  <p
                    [ngStyle]="{
                      visibility:
                        !checkIfEmpty('share', false, i) &&
                        !checkIfEmpty('stock', false, i) &&
                        stock.position_value !== null &&
                        isFinit(stock.position_value)
                          ? ''
                          : 'hidden',
                    }"
                  >
                    Position value
                    @if (!showTradeLink()) {
                      <br />
                    }
                    ${{ stock.position_value | number: '1.0-0' }}
                  </p>
                </div>
              </div>
            </div>
          </td>
        }
      </tr>
      <tr class="s-calls marker-row pb-0">
        <th>
          <div class="th-div">Rise In</div>
        </th>
        @for (stock of rise; track stock.header_id; let i = $index) {
          <td
            [ngClass]="{ 'active-col': indexOfActiveCol - 1 == i }"
            class="stock"
          >
            <div
              [ngStyle]="{
                visibility:
                  stock.value !== null && isFinit(stock.value) && !checkIfEmpty('strike', false, i) ? '' : 'hidden',
              }"
              class="wh-100 all-center drop-in"
              class="{{ getBGLightColor(i, false) }}"
            >
              @if (stock.value !== null && stock.value !== 'null' && !isNaNValue(stock.value)) {
                <div class="up-arrow"></div>
              }
              {{ stock.value | number: '1.0-0' }}
              @if (stock.value !== null && stock.value !== 'null' && !isNaNValue(stock.value)) {
                %
              }
            </div>
          </td>
        }
      </tr>
      <tr class="s-calls marker-row ptb-0">
        <th>
          <div class="th-div">Premium Per Day. <span>Total</span></div>
        </th>
        @for (stock of call_premium_per_day; track stock.header_id; let i = $index) {
          <td
            [ngClass]="{ 'active-col': indexOfActiveCol - 1 == i }"
            class="stock"
          >
            <div
              [ngStyle]="{
                visibility:
                  !checkIfEmpty('premium', false, i) &&
                  !checkIfEmpty('share', false, i) &&
                  stock.premium_per_day !== null &&
                  isFinit(stock.premium_per_day)
                    ? ''
                    : 'hidden',
              }"
              class="whiteDiv premium-per-day"
              class="{{ getBGLightColor(i, false) }}"
            >
              <div
                [ngStyle]="{
                  visibility:
                    !checkIfEmpty('premium', false, i) &&
                    !checkIfEmpty('strike', false, i) &&
                    !checkIfEmpty('expiration', false, i) &&
                    stock.premium_per_day !== null &&
                    isFinit(stock.premium_per_day)
                      ? ''
                      : 'hidden',
                }"
              >
                ${{ stock.premium_per_day | number: '1.0-0' }}
              </div>
              <div
                [ngStyle]="{
                  visibility:
                    !checkIfEmpty('premium', false, i) &&
                    !checkIfEmpty('share', false, i) &&
                    stock.premium_collected !== null &&
                    isFinit(stock.premium_collected)
                      ? ''
                      : 'hidden',
                }"
                class="blur-rr"
              >
                ${{ stock.premium_collected | number: '1.0-0' }}
              </div>
            </div>
          </td>
        }
      </tr>
      <tr class="s-calls marker-row pt-0">
        <th>
          <div class="th-div">
            <svg
              [matTooltip]="roiLegendCall"
              [matTooltipPosition]="'below'"
              [matTooltipHideDelay]="0"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 16 16"
              class="help"
            >
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
              <path
                d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"
              />
            </svg>
            Premium Annualized
          </div>
        </th>
        @for (stock of call_premium_annularized; track stock.header_id; let i = $index) {
          <td
            [ngClass]="{ 'active-col': indexOfActiveCol - 1 == i }"
            class="stock"
          >
            @if (stock.value > roiUpperBound) {
              <div
                [ngStyle]="{
                  visibility:
                    !checkIfEmpty('expiration', false, i) &&
                    !checkIfEmpty('premium', false, i) &&
                    stock.value !== null &&
                    isFinit(stock.value)
                      ? ''
                      : 'hidden',
                }"
                class="bg-yellow"
              >
                {{ stock.value | number: '1.0-0' }}%
              </div>
            }
            @if (stock.value < roiLowerBound || !stock.value) {
              <div
                [ngStyle]="{
                  visibility:
                    !checkIfEmpty('expiration', false, i) &&
                    !checkIfEmpty('premium', false, i) &&
                    stock.value !== null &&
                    isFinit(stock.value)
                      ? ''
                      : 'hidden',
                }"
                class="bg-red"
              >
                {{ stock.value | number: '1.0-0' }}%
              </div>
            }
            @if (stock.value >= roiLowerBound && stock.value <= roiUpperBound) {
              <div
                [ngStyle]="{
                  visibility:
                    !checkIfEmpty('expiration', false, i) &&
                    !checkIfEmpty('premium', false, i) &&
                    stock.value !== null &&
                    isFinit(stock.value)
                      ? ''
                      : 'hidden',
                }"
                class="bg-green"
              >
                {{ stock.value | number: '1.0-0' }}%
              </div>
            }
          </td>
        }
      </tr>
      <tr class="s-calls marker-row">
        <th>
          <div class="th-div">
            <svg
              [matTooltip]="callProfit90Tooltip"
              [matTooltipPosition]="'below'"
              [matTooltipHideDelay]="0"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 16 16"
              class="help"
            >
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
              <path
                d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"
              />
            </svg>
            90% Profit.
            <ul>
              <li>Target</li>
              <li>Value</li>
            </ul>
          </div>
        </th>
        @for (stock of call_profit; track stock.header_id; let i = $index) {
          <td
            [ngClass]="{ 'active-col': indexOfActiveCol - 1 == i }"
            class="stock"
          >
            <div class="whiteDiv value-center-dotted">
              <div>
                @if (showTradeLink() && profitLinkShow(i, false) && !isValueZero(i, ['share'], false)) {
                  <div>
                    <div
                      [class]="
                        tradeLinkTradingPanelDisable(i, ['expiration', 'ticker', 'premium', 'strike'], false)
                          ? 'disabled'
                          : ''
                      "
                      class="wheel-profit-link"
                    >
                      @if (tradeLinkTradingPanelDisable(i, ['expiration', 'ticker', 'premium', 'strike'], false)) {
                        <a
                          [matTooltip]="tradeLinkTooltip"
                          [matTooltipDisabled]="!tradeLinkTooltipEnabled"
                          [matTooltipPosition]="'below'"
                        >
                          ${{ stock.taking | number: '1.2-2' }}
                        </a>
                      } @else {
                        <a (click)="profitLinkTradingPanel(i, 'C', stock.taking)">
                          ${{ stock.taking | number: '1.2-2' }}
                        </a>
                      }
                    </div>
                  </div>
                } @else {
                  <div [ngStyle]="{ visibility: !checkIfEmpty('premium', false, i) ? '' : 'hidden' }">
                    ${{ stock.taking | number: '1.2-2' }}
                  </div>
                }
              </div>
              <div
                [ngStyle]="{
                  visibility:
                    !checkIfEmpty('strike', false, i) &&
                    !checkIfEmpty('premium', false, i) &&
                    stock.value !== null &&
                    isFinit(stock.value)
                      ? ''
                      : 'hidden',
                }"
              >
                ${{ stock.value | number: '1.2-2' }}
              </div>
            </div>
          </td>
        }
      </tr>
      <tr class="s-calls marker-row pb-0">
        <th>
          <div class="th-div dark-rm"><strong>Profit Potential</strong></div>
        </th>
        @for (stock of call_expiration; track stock.header_id; let i = $index) {
          <td
            [ngClass]="{ 'active-col': indexOfActiveCol - 1 == i }"
            class="t-middle"
            class="stock"
          >
            <div class="t-line"></div>
          </td>
        }
      </tr>
      <tr class="s-calls marker-row pb-0 pt-0">
        <th>
          <div class="th-div">Total Gain</div>
        </th>
        @for (stock of call_total_gain; track stock.header_id; let i = $index) {
          <td
            [ngClass]="{ 'active-col': indexOfActiveCol - 1 == i }"
            class="stock"
          >
            <div
              [ngStyle]="{
                visibility:
                  !checkIfEmpty('strike', false, i) &&
                  !checkIfEmpty('premium', false, i) &&
                  !checkIfEmpty('share', false, i) &&
                  stock.value !== null &&
                  isFinit(stock.value)
                    ? ''
                    : 'hidden',
              }"
              class="total-tbl"
            >
              ${{ stock.value | number: '1.2-2' }}
            </div>
          </td>
        }
      </tr>
      <tr class="s-calls marker-row pb-0 pt-0">
        <th>
          <div class="th-div">
            Stock Gain.
            <ul>
              <li>Taking</li>
              <li>Value</li>
            </ul>
          </div>
        </th>
        @for (stock of call_stock_gain; track stock.header_id; let i = $index) {
          <td
            [ngClass]="{ 'active-col': indexOfActiveCol - 1 == i }"
            class="stock"
          >
            <div class="whiteDiv value-center-dotted">
              <div
                [ngStyle]="{
                  visibility:
                    !checkIfEmpty('strike', false, i) &&
                    !checkIfEmpty('stock', false, i) &&
                    !checkIfEmpty('share', false, i) &&
                    stock.excercised !== null &&
                    isFinit(stock.excercised)
                      ? ''
                      : 'hidden',
                }"
                class="blur-rm"
              >
                ${{ stock.excercised | number: '1.2-2' }}
              </div>
              <div
                [ngStyle]="{
                  visibility:
                    !checkIfEmpty('strike', false, i) &&
                    !checkIfEmpty('stock', false, i) &&
                    stock.holding !== null &&
                    isFinit(stock.holding)
                      ? ''
                      : 'hidden',
                }"
                class="blur-rm"
              >
                {{ stock.holding | number: '1.0-0' }}%
              </div>
            </div>
          </td>
        }
      </tr>
      <tr class="s-calls marker-row pt-0">
        <th>
          <div class="th-div">
            <svg
              [matTooltip]="callMaxProfit90Tooltip"
              [matTooltipPosition]="'right'"
              [matTooltipHideDelay]="0"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 16 16"
              class="help"
            >
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
              <path
                d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"
              />
            </svg>
            90% Max Profit.
            <ul>
              <li>Target</li>
              <li>Value</li>
            </ul>
          </div>
        </th>
        @for (stock of call_max_profit; track stock.header_id; let i = $index) {
          <td
            [ngClass]="{ 'active-col': indexOfActiveCol - 1 == i }"
            class="stock"
          >
            <div class="whiteDiv value-center-dotted">
              <div
                [ngStyle]="{
                  visibility:
                    !checkIfEmpty('strike', false, i) &&
                    !checkIfEmpty('premium', false, i) &&
                    !checkIfEmpty('stock', false, i) &&
                    stock.taking !== null &&
                    isFinit(stock.taking)
                      ? ''
                      : 'hidden',
                }"
                class="blur-rm"
              >
                ${{ stock.taking | number: '1.2-2' }}
              </div>
              <div
                [ngStyle]="{
                  visibility:
                    !checkIfEmpty('strike', false, i) &&
                    !checkIfEmpty('premium', false, i) &&
                    !checkIfEmpty('stock', false, i) &&
                    !checkIfEmpty('share', false, i) &&
                    stock.value !== null &&
                    isFinit(stock.value)
                      ? ''
                      : 'hidden',
                }"
                class="blur-rm"
              >
                ${{ stock.value | number: '1.2-2' }}
              </div>
            </div>
          </td>
        }
      </tr>
    </tbody>
  </table>
</div>
